module.exports = __webpack_public_path__ + "static/media/gangplank.d2672fd2.png";